import { AdminDeliveryProposalCreatePage } from "@/pages/admin-delivery-proposal-create";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/admin/cargos/$id/delivery-proposals/create",
)({
  component: () => {
    const { id } = useParams({ strict: false });
    return <AdminDeliveryProposalCreatePage offerCargoIdStr={id} />;
  },
});
